import React from 'react'
import { Col, Row } from 'react-bootstrap'
import BioField from './BioField'
import CastField from './CastField'
import Crew from './Crew'
import Genre from './genre'
import Language from './Language'
import Moviename from './moviename'
import Movienamete from './Movienamete'
import PersonMovieSuggest from './PersonMovieSuggest'
import WikipediaCheckbox from './wikipediaCheckbox'
import ProductionCompany from './ProductionCompney'
import AccordionsContainer from './Acoordiancontainer'
import MissingPersonsComponent from './AddMissingPersonsComponent'
import PNComponent from './PNComponent'

const EnglishandTeluguFields = props => {
  // props from parent to this file
  const {
    moviePersons,
    movieMode,
    inputData,
    updateInputData,
    sendinputdata,
    movieData,
    sendBooleanValueChangeDone,
    handleActiveChange,
    active,
    modeUrl,
    editData,
    setIsLoading,
  } = props
  const Personswikis = moviePersons?.map(item => `${item.personWikiURL}===`).toString()
  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <Moviename
              inputData={inputData}
              modeUrl={modeUrl}
              active={active}
              editData={editData}
              sendtruevalue={sendBooleanValueChangeDone}
              movieID={inputData.movieName}
              sendmoviename={(fieldname, fieldvalue) => updateInputData(fieldname, fieldvalue)}
            />
          </div>
        </Col>
        {inputData.movieName.length > 1 && (
          <Col md={6} xs={12}>
            <Movienamete
              inputData={inputData}
              sendtruevalue={sendBooleanValueChangeDone}
              movieIDen={inputData.movieName}
              movieID={inputData.movieNamete}
              sendmoviename={(fieldname, fieldvalue) => updateInputData(fieldname, fieldvalue)}
            />
          </Col>
        )}
      </Row>
      {modeUrl && (
        <WikipediaCheckbox
          Id={1}
          field={'movieName'}
          active={active}
          handleActiveChange={handleActiveChange}
        />
      )}
      <BioField
        inputData={inputData}
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        updateInputData={updateInputData}
        sendtruevalue={sendBooleanValueChangeDone}
      />
      <AccordionsContainer
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        movieMode={movieMode}
        setIsLoading={setIsLoading}
        movieData={movieData}
        editOttAndNewsPermission={props.editOttAndNewsPermission}
        DeleteOttAndNewsPermission={props.DeleteOttAndNewsPermission}
        ApproveOttAndNewsPermission={props.ApproveOttAndNewsPermission}
      />
      <Genre
        inputData={inputData}
        genReTelugu={inputData.genRete}
        sendtruevalue={sendBooleanValueChangeDone}
        genRe={inputData.genRe}
        sendinputdata={sendinputdata}
      />
      <PNComponent
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendtruevalue={sendBooleanValueChangeDone}
        movieMode={movieMode}
      />
      <Crew
        editData={editData}
        modeUrl={modeUrl}
        handleActiveChange={handleActiveChange}
        active={active}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={0}
        name={'Director'}
        inputFieldEnglish={'Moviedirector'}
        inputFieldTelugu={'Moviedirectorte'}
        inputData={inputData}
      />
      <Crew
        editData={editData}
        handleActiveChange={handleActiveChange}
        modeUrl={modeUrl}
        active={active}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={5}
        name={'Screenplay'}
        inputFieldEnglish={'MovieScreenPlay'}
        inputFieldTelugu={'MovieScreenPlayTelugu'}
        inputData={inputData}
      />
      <Crew
        editData={editData}
        modeUrl={modeUrl}
        handleActiveChange={handleActiveChange}
        active={active}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={6}
        name={'Story'}
        inputFieldEnglish={'story'}
        inputFieldTelugu={'storyte'}
        inputData={inputData}
      />
      <Crew
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={1}
        name={'Producer'}
        inputFieldEnglish={'MovieProducer'}
        inputFieldTelugu={'MovieProducerTelugu'}
        inputData={inputData}
      />
      <CastField
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        movieMode={movieMode}
        sendtruevalue={sendBooleanValueChangeDone}
        movieData={movieData}
        inputData={inputData}
        sendinputdata={sendinputdata}
      />
      <MissingPersonsComponent moviePersons={moviePersons} Personswikis={Personswikis} />
      <Crew
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={7}
        name={'Cinematographer'}
        inputFieldEnglish={'MovieCimematographer'}
        inputFieldTelugu={'MovieCimematographerTelugu'}
        inputData={inputData}
      />

      <Crew
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={8}
        name={'Editor'}
        inputFieldEnglish={'MovieEditor'}
        inputFieldTelugu={'MovieEditorte'}
        inputData={inputData}
      />

      <Crew
        editData={editData}
        modeUrl={modeUrl}
        active={active}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={3}
        name={'Musician'}
        inputFieldEnglish={'Moviemusicby'}
        inputFieldTelugu={'Moviemusicbyte'}
        inputData={inputData}
      />
      <Crew
        editData={editData}
        active={active}
        modeUrl={modeUrl}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={2}
        name={'Writer'}
        inputFieldEnglish={'Moviewritter'}
        inputFieldTelugu={'Moviewritterte'}
        inputData={inputData}
      />
      <PersonMovieSuggest
        editData={editData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        inputData={inputData}
      />
      <ProductionCompany
        modeUrl={modeUrl}
        editData={editData}
        handleActiveChange={handleActiveChange}
        active={active}
        sendinputdata={sendinputdata}
        weight={12}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        name={'ProductionCompany'}
        inputField1={'MovieProductionCompany'}
        inputField2={'MovieProductionCompanyTelugu'}
        inputData={inputData}
      />
      <Crew
        modeUrl={modeUrl}
        editData={editData}
        active={active}
        handleActiveChange={handleActiveChange}
        sendtruevalue={sendBooleanValueChangeDone}
        sendinputdata={sendinputdata}
        movieData={movieData}
        weight={4}
        name={'Dialogue Writer'}
        inputFieldEnglish={'MovieDialoge'}
        inputFieldTelugu={'MovieDialogete'}
        inputData={inputData}
      />
      <ProductionCompany
        weight={13}
        modeUrl={modeUrl}
        handleActiveChange={handleActiveChange}
        active={active}
        sendinputdata={sendinputdata}
        editData={editData}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        name={'Distibutor'}
        inputField1={'MovieDistibutor'}
        inputField2={'MovieDistibutorTelugu'}
        inputData={inputData}
      />
      <Language
        handleActiveChange={handleActiveChange}
        active={active}
        modeUrl={modeUrl}
        editData={editData}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        inputData={inputData}
        sendinputdata={sendinputdata}
        language={inputData.language}
      />
    </div>
  )
}

export default EnglishandTeluguFields
